__turbopack_context__.v({
  "container": "index-module__1g80Da__container",
  "containerWrapper": "index-module__1g80Da__containerWrapper",
  "header": "index-module__1g80Da__header",
  "imageWrapper": "index-module__1g80Da__imageWrapper",
  "item": "index-module__1g80Da__item",
  "itemsWrapper": "index-module__1g80Da__itemsWrapper",
  "menu": "index-module__1g80Da__menu",
  "menuItem": "index-module__1g80Da__menuItem",
  "text": "index-module__1g80Da__text",
});
